import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { MenuController, NavController, Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { EventsService } from './services/events/events.service';
import { UserDataService } from './services/user-data/user-data.service';
import { PermissionCheckerService } from './services/permission-checker/permission-checker.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  showFooter: boolean = false;
  showSettings: boolean = false;
  app_version: string;

  constructor(
    private router: Router,
    private navController: NavController,
    private menu: MenuController,
    private userData: UserDataService,
    private eventsService: EventsService,
    private permissionChecker: PermissionCheckerService) {
  }

  // this is used for deeplinking directly with the app. 
  //async setupListener() {
  //  App.addListener('appUrlOpen', (data: URLOpenListenerEvent) => {
  //    console.log('App opened with URL:', JSON.stringify(data));
  //    var openUrl = data.url;
  //    //this shows up as quadra://test/123
  //    var pathArray = openUrl.split("quadra:/");
  //    var appPath = pathArray.pop();
  //    if (appPath) {
  //      this.router.navigate([appPath]);
  //    }
  //  });
  //}

  async ngOnInit() {
    this.app_version = environment.APP_VERSION;

    this.eventsService.getLoginSubject().subscribe(async data => 
    {
      this.showFooter = true;

      this.determineSettingsVisibilityState();
    });
    this.eventsService.getLogoutSubject().subscribe(data => {
      this.showFooter = false;
      this.showSettings = false;
    });

    let loggedIn: boolean = await this.userData.hasLoggedIn();

    this.showFooter = loggedIn;
    //clear the urlToRedirect if user refreshes the page or restarts the app
    await this.userData.resetUrlToRedirect(); 

    if (loggedIn)
    {
      this.determineSettingsVisibilityState();
    }


    // After a full reload make sure to send the user to the home/dashboard page.
    //await this.navController.navigateRoot(['']);
    // ^ commenting this out to allow users to navigate directly to recommendations and quotes
  }

  async logout() {
    this.showFooter = false;
    await this.menu.toggle(); // close the menu before leaving
    await this.userData.removeLoginData();
    this.router.navigate(['/login']);
  }

  determineSettingsVisibilityState()
  {
    forkJoin(
      [
        this.permissionChecker.canSeeUserDashboardSettings(),
        this.permissionChecker.canSeeDefaultDashboardSettings()
      ]
    ).subscribe(([canSeeUserDashboardSettings, canSeeDefaultDashboardSettings]: [boolean, boolean]) =>
    {
      this.showSettings = 
        canSeeUserDashboardSettings ||
        canSeeDefaultDashboardSettings;
    });
  }

  // Before reloading the full page of the application ask for confirmation.
  @HostListener('window:beforeunload')
  canDeactivate() {
    return false;
  }

}
